module.exports = __webpack_public_path__ + "static/img/img-card-car-v1.90b5d58.jpg";